import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

// TODO: Replace with actual HugeIcons SVG path for shield icon
// This is a placeholder - user will provide the correct path from HugeIcons
export const ShieldIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest}>
      {/* Placeholder path - needs to be replaced with HugeIcons shield path */}
      <path
        d="M12 2L4 5v6c0 5.55 3.84 10.74 8 12 4.16-1.26 8-6.45 8-12V5l-8-3z"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
